import React from 'react';
import ConfirmModal from 'components/ConfirmModal';
import ImportModal from 'components/ImportModal';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import {
  V1_IMPORT_LIBRARY,
  V1_IMPORT_LIBRARY_TEMPLATE,
  V1_IMPORT_LIBRARY_TEMPORARY,
} from 'api/ingredients/library/constants';
import { hideImportModal, onSuccessImport } from 'actions/ingredients/library';
import './LibraryImportModal.css';
import * as actNotif from 'actions/notifications';
import * as apiIng from 'api/ingredients';
import * as act from 'actions';
import * as clevertapIngredientLibrary from 'clevertap/ingredient/library';
import { INGREDIENT_LIBRARY } from 'utils/uploadS3Constants';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class LibraryImportModal extends ImportModal {
  static SELECT_TYPE = 'select_type';

  static SHOW_IMPORT_MODAL = 'show_import_modal';

  static SHOW_CONFIRM_MODIFY_MODAL = 'show_confirm_modify_modal';

  state = {
    act: LibraryImportModal.SHOW_IMPORT_MODAL,
    type: 'modify',
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({
        act: LibraryImportModal.SELECT_TYPE,
        type: 'modify',
      });
    }
  }

  render() {
    const replace = this.state.type === 'replace';
    const modify = this.state.type === 'modify';
    const { selectedOutletIds, business, outlets } = this.props;

    return (
      <div>
        {this.state.act !== LibraryImportModal.SHOW_CONFIRM_MODIFY_MODAL && (
          <ImportModal
            pathImporting="outlet"
            selectedOutletIds={this.props.selectedOutletIds}
            validate={validateValueStock}
            dispatch={this.props.dispatch}
            templateImportUrl={V1_IMPORT_LIBRARY_TEMPLATE}
            temporaryImportUrl={V1_IMPORT_LIBRARY_TEMPORARY}
            importUrl={`${V1_IMPORT_LIBRARY}?replace=${replace}&modify=${modify}`}
            namespace="libraries"
            onCancel={this._onCancel}
            className={'library-import-modal'}
            onBack={() => {
              this.setState({ act: LibraryImportModal.SELECT_TYPE });
            }}
            show={this.props.show}
            afterSuccessCallback={() => {
              clevertapIngredientLibrary.libraryIngredientImport({
                eventName: this.state.type,
                selectedOutletIds,
                outlets,
                business,
              });
              this.props.dispatch(onSuccessImport());
            }}
            onErrorCallback={errors => {
              this.props.dispatch(actNotif.error(errors[0]));
            }}
            templatePrefix="Ingredients - "
            body={this._body()}
            header={this._header()}
            footer={this._footer()}
            filterNamespace="items"
            csvHeaders={[
              'Internal ID (DO NOT EDIT)',
              'Name',
              'Category',
              'In Stock (DO NOT EDIT)',
              'Unit',
              'Alert',
              'Stock Alert',
            ]}
            confirmImportBody={this._confirmImportBody()}
            confirmImportHeader={this._confirmImportHeader()}
            confirmPromiseFunction={this._confirmFunction}
            paramAfterUploadConfirm="&ignore_cogs_validation=true"
            afterUploadConfirmModalHeader={`Confirm Import Ingredients (${capitalizeFirstLetter(
              this.state.type
            )})`}
            afterUploadConfirmModalSubHeader="Please confirm import ingredients of the value(s) in field(s) that cannot be updated:"
            usingSpringImport="true"
            importNamespace={INGREDIENT_LIBRARY}
          />
        )}
        <ConfirmModal
          showModal={
            this.state.act === LibraryImportModal.SHOW_CONFIRM_MODIFY_MODAL
          }
          onHide={this._onHideModal}
          title={'Modify Ingredient'}
          description={
            <p>
              Are you sure you want to modify the ingredient library?
              <br />
              If your item has COGS Tracking OR associated with Recipe, then the
              Cost Amount of the ingredient cannot be modified
            </p>
          }
          onConfirm={this._onProceed}
          baseColor="danger"
          confirmTitle="Modify"
        />
      </div>
    );
  }

  _onHideModal = () => {
    this.setState({
      act: LibraryImportModal.SELECT_TYPE,
    });
  };

  _onProceed = () => {
    this.setState({
      act: LibraryImportModal.SHOW_IMPORT_MODAL,
    });
  };

  _header = () => {
    if (this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
      return null;
    }
    return <Modal.Title>Choose Import Type</Modal.Title>;
  };

  _footer = () => {
    if (this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
      return null;
    }
    return (
      <div>
        <span className="pull-left">
          <button onClick={this._onCancel} className="btn btn-default">
            Cancel
          </button>
        </span>
        <span className="pull-right">
          <button onClick={this._onNext} className="btn btn-primary">
            Next
          </button>
        </span>
      </div>
    );
  };

  _body = () => {
    if (this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
      return null;
    }
    return (
      <div className="modal-below-header">
        <div
          className="choose-import-box"
          onClick={() => {
            this._onClickType('modify');
          }}
        >
          <div className="circle">
            {this.state.type === 'modify' ? '✓' : ''}
          </div>
          <div className="label-modify-item-library">
            Modify Ingredient Library
          </div>
          <div className="description">
            Add new ingredients and update your existing ones. Ingredients
            cannot be deleted, only altered
          </div>
        </div>
        <div
          className="choose-import-box"
          onClick={() => {
            this._onClickType('replace');
          }}
        >
          <div className="circle">
            {this.state.type === 'replace' ? '✓' : ''}
          </div>
          <div className="label-modify-item-library">
            Replace Ingredient Library
          </div>
          <div className="description">
            Overwrite your existing ingredients. All ingredients will be deleted
            and replaced
          </div>
        </div>
      </div>
    );
  };

  _confirmImportBody = () => {
    return (
      <p>
        Are you sure you want to replace the ingredient library?
        <br />
        If you replace the ingredient library, all recipes will be deleted
      </p>
    );
  };

  _confirmImportHeader = () => {
    return 'Replace Ingredient Library';
  };

  /**
   * return true if ingredients have recipe, it means user must confirm all ingredient must be deleted first
   * @return {Promise}
   * @private
   */
  _confirmFunction = () => {
    return new Promise((resolve, reject) => {
      if (this.state.type === 'modify') {
        resolve(false);
      }
      act.showLoadingSpinner(true);
      apiIng
        .getHaveRecipe({})
        .then(response => {
          act.showLoadingSpinner(false);
          resolve(response.data);
        })
        .catch(error => {
          act.showLoadingSpinner(false);
          reject(error.message);
        });
    });
  };

  _onCancel = () => {
    this.props.dispatch(hideImportModal());
  };

  _onNext = () => {
    if (this.state.type === 'modify') {
      this.setState({
        act: LibraryImportModal.SHOW_CONFIRM_MODIFY_MODAL,
      });
    } else {
      this.setState({
        act: LibraryImportModal.SHOW_IMPORT_MODAL,
      });
    }
  };

  _onClickType = type => {
    this.setState({
      type,
    });
  };
}

function validateValueStock(resultOBject) {
  const valueStockCell = 6;

  for (let i = 1; i <= resultOBject.length - 1; i++) {
    if (resultOBject[i].length < 7) {
      return [
        { cell: resultOBject[i][valueStockCell], message: 'invalid format' },
      ];
    }
    const splitedValueStock = resultOBject[i][valueStockCell].split('.');
    if (splitedValueStock.length > 1 && splitedValueStock[1].length > 2) {
      return [
        {
          cell: resultOBject[i][valueStockCell],
          message: 'max two digits behind the decimal',
        },
      ];
    }
  }
}

LibraryImportModal.propTypes = {
  selectedOutletIds: PropTypes.array,
};

export default LibraryImportModal;
